<template>
  <div class="neighbourhood">
    <div class="neighbourhood__grid">
      <div class="neighbourhood__dropdown" ref="dropdown">
        <Dropdown id="select-neighbourhoods" :data="getNeighbourhoodsList"
          :label="_translate('local.filters.city.label')" :selection="getNeighbourhoodSelection"
          :display="getUNeighbourhoodsDisplay" @dropdownChange="setUpdatedNeighbourhoods" searchable hiddenlabel />
      </div>
      <div class="neighbourhood__top-wrap">
        <div ref="top">
          <h3 v-html="title"></h3>
          <div class="neighbourhood__top">
            <div v-for="result in getTopNeighbourhoods" class="card__container" :class="isActiveRow(result.key)">
              <div class="rank">
                <svg role="presentation" width="58" height="38" viewBox="0 0 58 38" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path class="rank-decoration"
                    d="M55.4532 25.9302C55.4532 11.6038 43.8494 0 29.523 0C15.1965 0 3.59277 11.6038 3.59277 25.9302C3.59277 29.7549 4.43551 33.3852 5.92649 36.6264H53.1843C54.6105 33.3852 55.4532 29.7549 55.4532 25.9302Z" />
                  <path d="M3.91711 36.6265H54.481" stroke="#4D4D4D" stroke-width="0.972383" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M1 36.6265H2.62064" stroke="#4D4D4D" stroke-width="0.972383" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M55.7776 36.6265H57.3982" stroke="#4D4D4D" stroke-width="0.972383" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span v-text="result.rank" class="rank"></span>
              </div>
              <h4 v-text="result.title" class="name"></h4>
              <p class="percentage"><span v-html="result.percent"></span> <span
                  v-text="_translate('local.region.table.visitors')"></span></p>
              <p class="total"><span v-text="result.total"></span> <span
                  v-text="_translate('local.region.table.visitors') "></span></p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="neighbourhood__remaining" ref="remaining">
          <table class="neighbourhood__remaining-table" ref="table">
            <thead class="neighbourhood__remaining-head" ref="thead">
              <tr>
                <th id="neighbourhood-rank"><button class="neighbourhood__remaining-header-button"
                    @click="setOrderby('rank')"><span v-text="_translate('local.region.table.rank')"></span>
                    <svg class="neighbourhood__sorter" role="presentation" width="5" height="8" viewBox="0 0 5 8"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.33333 0L4.35406 3H0.312607L2.33333 0Z" fill="#737373"
                        v-show="showOrderIndicator('rank', 'ASC')" />
                      <path d="M2.33332 8L0.312598 5L4.35405 5L2.33332 8Z" fill="#737373"
                        v-show="showOrderIndicator('rank', 'DESC')" />
                    </svg>
                  </button></th>
                <th id="neighbourhood-name"><button class="neighbourhood__remaining-header-button"
                    @click="setOrderby('key')"><span v-text="_translate('local.region.table.neighbourhood')"></span>
                    <svg class="neighbourhood__sorter" role="presentation" width="5" height="8" viewBox="0 0 5 8"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.33333 0L4.35406 3H0.312607L2.33333 0Z" fill="#737373"
                        v-show="showOrderIndicator('key', 'ASC')" />
                      <path d="M2.33332 8L0.312598 5L4.35405 5L2.33332 8Z" fill="#737373"
                        v-show="showOrderIndicator('key', 'DESC')" />
                    </svg>
                  </button></th>
                <th id="neighbourhood-percent"><button class="neighbourhood__remaining-header-button"
                    @click="setOrderby('percent')"><span
                      v-text="_translate('local.region.table.percentagerank')"></span>
                    <svg class="neighbourhood__sorter" role="presentation" width="5" height="8" viewBox="0 0 5 8"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.33333 0L4.35406 3H0.312607L2.33333 0Z" fill="#737373"
                        v-show="showOrderIndicator('percent', 'ASC')" />
                      <path d="M2.33332 8L0.312598 5L4.35405 5L2.33332 8Z" fill="#737373"
                        v-show="showOrderIndicator('percent', 'DESC')" />
                    </svg>
                  </button></th>
                <th id="neighbourhood-total"><button class="neighbourhood__remaining-header-button"
                    @click="setOrderby('total')"><span v-text="_translate('local.region.table.numberrank')"></span>
                    <svg class="neighbourhood__sorter" role="presentation" width="5" height="8" viewBox="0 0 5 8"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.33333 0L4.35406 3H0.312607L2.33333 0Z" fill="#737373"
                        v-show="showOrderIndicator('total', 'ASC')" />
                      <path d="M2.33332 8L0.312598 5L4.35405 5L2.33332 8Z" fill="#737373"
                        v-show="showOrderIndicator('total', 'DESC')" />
                    </svg>
                  </button></th>
              </tr>
            </thead>
            <tbody :style="getTableHeight()" ref="tbody">
              <tr v-for="result in getRemainingNeighbourhoods" :ref="result.key" class="neighbourhood__remaining-row"
                :class="isActiveRow(result.key)">
                <td headers="neighbourhood-rank"><span v-text="result.rank"></span></td>
                <td headers="neighbourhood-name"><span v-text="result.title"></span></td>
                <td headers="neighbourhood-percent" class="percentage"><span v-html="result.percent"></span></td>
                <td headers="neighbourhood-total" class="total"><span v-text="result.total"></span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

	import Dropdown from '@/components/Dropdown.vue'

	export default {

    data: function() {

      return {
        selected: '--',
        selectedLabel: '',
        reverse: false,
        orderby: 'rank',
        order: 'numeric',
        columns: [],
        tableHeight: 0,
      }

    },

    mounted: function() {
      this.setColumnWidths();
      this.selectedLabel = this._translate('local.neighbourhoods.select');
      window.addEventListener('resize', this.setColumnWidths);
    },

	  components: {
	  	Dropdown,
	  },

		props: {

			title: {
				type: String,
				default: 'Heading'
			},

			data: {
				type: Object,
				default: () => {}
			},

		},

		computed: {

      getTopNeighbourhoods: function () {
        return this.getNeighourhoods(true);
      },

      getRemainingNeighbourhoods: function () {
        let data = this.getNeighourhoods();
        let key = this.orderby;
        if ( key === 'percent' || key === 'total' ) {
          key = 'rank'
        }
        data.sort((a,b) => {

          let _a = a[key];
          let _b = b[key];
          if ( this.order === 'numeric' || key === 'rank' ) {
            let _a = Number(_a);
            let _b = Number(_b);
          } else if ( this.order === 'percent' ) {
            let _a = Number(_a.replace('%',''));
            let _b = Number(_b.replace('%',''));
          }

          if (_a < _b) {
            return this.reverse ? 1 : -1;
          }
          if (_a > _b) {
            return this.reverse ? -1 : 1;
          }
          return 0;          
        });
        return data;
      },

	  	getNeighbourhoodsList: function() {
	  		var data = {};
        for (const key in this.data.data) {  
        	data[key] = {
	  				'display': this.getDisplayName(key),
	  				'key': key,
	  			};
        }
        return Object.keys(data).sort().reduce(
          (obj, key) => { 
            obj[key] = data[key]; 
            return obj;
          }, 
          {}
        );        
	  	},
      
      getUNeighbourhoodsDisplay: function() {
        return this.$data.selectedLabel;
      },

      getNeighbourhoodSelection: function() {
        return this.$data.selected;
      },

		},

		methods: {

      getDisplayName(key) {
        return key.substring(1);
      },

      getNeighourhoods: function (top = false) {

        const threshold = 4;
        let neighourhoods = [];
        let i = 0;
        const total = this.data.total;
        for (const key in this.data.data) {  
          if ( (i > (threshold - 1) && top) || (i < threshold && !top) ) {
            i += 1;
            continue;
          }     
          let item = this.data.data[key];
          neighourhoods.push({
            rank : (i++) + 1,
            key : key,
            title: key.substring(1),
            total : this.thousandSeparators(item),
            percent: this.formatPercentage(item/total,1,false),
          });
        }    
        return neighourhoods;

      },

      getTableHeight: function() {
        if ( this.tableHeight ) {
          return 'height: ' + (this.isMobile ? 224 : this.tableHeight) + 'px';
        }
        return '';
      },

      setUpdatedNeighbourhoods: function(atts) {
        this.selected = atts.option.key
        this.selectedLabel = atts.option.display
        console.log(this.$refs['tbody']);
        console.log(this.$refs[atts.option.key][0]);
        this.gotoElement(this.$refs['tbody'], this.$refs[atts.option.key][0], 50);
      },

      setOrderby: function(orderby) {
        if ( this.orderby !== orderby ) {
          this.orderby = orderby;
          this.reverse = false;
        } else {
          this.reverse = !this.reverse;
        }
        this.orderNumeric = (orderby === 'key') ? false : true;
      },

      showOrderIndicator(key, order) {
        if ( this.orderby === key ) {
          if ( order === 'ASC' && !this.reverse ) {
            return true;
          } else if (order === 'DESC' && this.reverse ) {
            return true;
          }
          return false;
        }
        return true;
      },

      isActiveRow: function(key) {
        let c = '';
        if ( this.selected === key) {
          c += ' js-active';
        }
        return c;
      },

      setColumnWidths: function() {
        
        let $dropdown = this.$refs['dropdown'],
            $thead = this.$refs['thead'],
            $top = this.$refs['top'];

        let height = $top.offsetHeight - ($dropdown.offsetHeight + $thead.offsetHeight) - 8;
        this.tableHeight = height; 

        // let $table = this.$refs['table'],
        //     $row = $table.querySelector('thead tr'),
        //     $cells = $row.querySelectorAll('th'),
        //     widths = [];

        // for ( let i = 0; i < $cells.length; i++ ) {
        //   widths.push($cells[i].offsetWidth);
        // }

        // this.columns = widths;

      }
			
		}

	}

</script>

<style lang="scss">

	.neighbourhood {
    text-align: left;
    
    @include mq('tab') {
      background: $white;
      padding: 2.5rem;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08), 0px 2px 16px rgba(0, 0, 0, 0.06);
    }

    .percentage {
      color: $blue-dark;
    }
    .total {
      color: $red;
    }

    h3 {
      margin-top: 0;
    }
  }

  .neighbourhood__grid {
    font-size: 0.875rem;
    display: grid;
    grid-template-columns: 1fr;
    @include mq('tab') {
      grid-template-columns: 1fr 1fr;
    }
  }

  .neighbourhood__dropdown {
    padding-bottom: 1.5rem;
    @include mq('tab') {
      padding-bottom: .35rem;
      grid-column: 2;
      grid-row: 1;
    }
  }  

  .neighbourhood__top-wrap {
    @include mq('tab') {
      padding-right: 2.5rem;
      grid-column: 1;
      grid-row: 1 / 3;
    }
  }

  .neighbourhood__top {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr;
    @include mq('tab') {
      grid-template-columns: 1fr;
    }
    @include mq('lap') {
      grid-template-columns: 1fr 1fr;
    }    

    .card__container {
      padding: 1rem;
      border: 1px solid transparent;
      &.js-active {
        background-color: $blue-lighter;
        border-color: $blue;
        .rank-decoration {
          fill: #FFFFFF;
        }
      }
    }

    .rank {
      position: relative;
      span {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.125rem;
        color: $blue-dark;
        font-weight: bold;
      }
    }

    .rank-decoration {
      fill: #EBF3F5;
    }

    .name {
      font-weight: bold;
      font-size: .9em;
      margin-bottom: 0;
      margin-top: .75em;      
    }
    .percentage,
    .total {
      margin-bottom: 0;
      margin-top: .75em; 
      font-size: 0.85rem;
      span {
        font-weight: bold;
      }
    }
  }

  .neighbourhood__remaining {
    height: 100%;
    width: 100%;
    padding-top: 1.5rem;
    @include mq('tab') {
      padding-top: 0;
    }
  }

  .neighbourhood__remaining-table {
    border-collapse: collapse;
    width: calc(100% + 1.5rem);
    margin-left: -.75rem;
    margin-right: -.75rem;

    @include mq('tab') {
      margin-left: 0;
      margin-right: 0;
      width: 100%;
    }

    thead {
      display: block;
      tr {
        display: grid;
        grid-template-columns: 50px 1fr 80px 80px;
        width: 100%;
        @include mq('tab') {
          grid-template-columns: 60px 1fr 95px 95px;
        }
      } 
     }
    tbody {
      display: block;
      width: 100%;
    }
    tbody {
        height: 200px;       /* Just for the demo          */
        overflow-y: auto;    /* Trigger vertical scroll    */
        overflow-x: hidden;  /* Hide the horizontal scroll */
      tr {
        display: grid;
        grid-template-columns: 50px 1fr 80px 80px;
        width: 100%;
        @include mq('tab') {
          grid-template-columns: 60px 1fr 95px 95px;
        }        
      }        
    }    
  }

  .neighbourhood__remaining-head {
    padding-top: .5rem;
    padding-bottom: .5rem;
    margin-bottom: .5rem;
    border-bottom: 1px solid $mist;
    th {
      padding: .25rem .375rem;
      font-size: .8rem;
      @include mq('tab') {
        padding: .25rem .75rem;
      }
      &:first-child { padding-left: 0; }
      button {
        appearance: none;
        border: 0;
        white-space: nowrap;
        background: none;
        padding: 0;
        width: 100%;
        text-align: left;
        font-weight: 600;
        color: $grey;
        font-size: .75rem;
        @include mq('tab') {
          font-size: .875rem;
        }
      }
    }    
  }

  .neighbourhood__remaining-header-button {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    svg {
      position: relative;
      top: 1px;
      left: 4px;
    }
  }

  .neighbourhood__sorter {
    flex-shrink: 0;
  }

  .neighbourhood__remaining-row {
    border: 1px solid transparent;
    &:nth-child(odd) {
      background-color: $mist-light;
    }
    td {
      border: 0;
      span {
        border-top: 1px solid transparent;
        border-bottom: 1px solid transparent;
        padding: 0.375rem;
        font-weight: bold;
        display: block;
        @include mq('tab') {
          padding: .5rem .75rem;
        }
      }
      &:first-child span { padding-left: 4px; }      
      &.percentage,
      &.total {
        text-align: center;
      }
    }
    &.js-active {
      background-color: $blue-lighter;
      border-color: $blue;
    }
  }

</style>